import templateUrl from "emun.cart/cart-item-quick-view-actions.htm";

export default () => ({
  templateUrl
});
